var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSummarySalary = function SvgIconSummarySalary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.005 35.833c8.745 0 15.834-7.09 15.834-15.834S28.749 4.166 20.005 4.166 4.172 11.255 4.172 19.999c0 8.745 7.089 15.834 15.833 15.834Z",
    fill: "#15C480"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.09 18.958h-.69l.821-2.702a1.459 1.459 0 0 0-2.791-.846l-1.388 4.569-.004.012-.056.188-1.592-4.804a1.458 1.458 0 0 0-2.77 0l-1.592 4.804-.057-.184-.006-.02-1.385-4.565a1.459 1.459 0 0 0-2.792.846l.82 2.702h-.689a1.457 1.457 0 1 0 0 2.917h1.575l1.077 3.547a1.46 1.46 0 0 0 1.377 1.036h.02c.626 0 1.185-.402 1.383-1l1.652-4.988 1.652 4.986c.2.604.76 1.01 1.402 1a1.46 1.46 0 0 0 1.377-1.036l1.077-3.548h1.575a1.457 1.457 0 1 0 0-2.916l.004.002Z",
    fill: "#fff"
  })));
};
export default SvgIconSummarySalary;